import makeStyles from '@mui/styles/makeStyles';

function propsByType (widget) {

    if (widget.error) {
        return {
            height: '84px',
        };
    }
    if (widget.bannerType === 'dynamic') {
        return {
            height: '132px',
        };
    }

    else if (widget.bannerType === 'image') {
        return {
            height: '84px',
        };
    }

    // default solid
    return {
        height: '84px',
        backgroundColor: `${widget.bannerColour}`,
    };
}


function bannerImage (widget) {
    if (widget.error) {
        return {
            height: '84px',
        };
    }

    if (widget.bannerType === 'dynamic') {
        return {
            height: '132px',
        };
    }

    else if (widget.bannerType === 'image') {
        return {
            height: '84px',
        };
    }

    // default solid
    return {
       display: 'none',
    };
}

const styles = (theme) => ({

  bannerRoot: ({ widget }) => {
    if (!widget) return;

    const styles = {
      display: 'flex',
      zIndex: -10,
      position: 'absolute',
      top: '0px',
      left: '0px',
      width: '100%',
      ...propsByType(widget),
    };
 
    return styles;
  },

  bannerImage: ({ widget }) => {
    if (!widget) return;
    
    const styles = {
        width: '100%',
        ...bannerImage(widget),
    };

    return styles;
  },

});

export default styles;
export const useStyles = makeStyles(styles);
